export default "__VITE_PUBLIC_ASSET__681aa6ae__"